// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2CTrS","large":"styles_large__2cqPD"};